import * as React from "react";

function SvgIcons8Chrome(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#4caf50"
        d="M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z"
      />
      <path
        fill="#ffc107"
        d="M24 4v20l8 4-8.843 16H24c11.053 0 20-8.947 20-20S35.053 4 24 4z"
      />
      <path
        fill="#4caf50"
        d="M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z"
      />
      <path
        fill="#ffc107"
        d="M24 4v20l8 4-8.843 16H24c11.053 0 20-8.947 20-20S35.053 4 24 4z"
      />
      <path
        fill="#f44336"
        d="M41.84 15H24v13l-3-1L7.16 13.26h-.02C10.68 7.69 16.91 4 24 4c7.8 0 14.55 4.48 17.84 11z"
      />
      <path fill="#dd2c00" d="M7.158 13.264l8.843 14.862L21 27 7.158 13.264z" />
      <path fill="#558b2f" d="M23.157 44l8.934-16.059L28 25l-4.843 19z" />
      <path fill="#f9a825" d="M41.865 15H24l-1.579 4.58L41.865 15z" />
      <path
        fill="#fff"
        d="M33 24c0 4.969-4.031 9-9 9s-9-4.031-9-9 4.031-9 9-9 9 4.031 9 9z"
      />
      <path
        fill="#2196f3"
        d="M31 24c0 3.867-3.133 7-7 7s-7-3.133-7-7 3.133-7 7-7 7 3.133 7 7z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Chrome);
